<template>
  <div class="text-center">
    <div v-show="!isInputPhoneNum && !smsSent">
      <v-img
        :src="require('@/assets/castImg.jpg')"
        contain
        class="mx-auto mb-5"
        width="100vw"
        aspect-ratio="1"
      />

      <v-btn
        rounded
        outlined
        color="#6E5C26"
        width="250px"
        @click="toInputPhonenNum"
        class="mb-5"
        >電話番号ではじめる</v-btn
      >

      <div class="mt-5">
        <div class="text-center" style="font-size: 10px">
          18歳未満の方は、ご登録いただけません。
        </div>
        <div class="mt-2">
          <v-btn text class="login-footer" x-small @click="toPrivacyPolicy"
            >プライバシーポリシー</v-btn
          ><br />
          <v-btn text class="login-footer" x-small @click="toTerms"
            >特定商取引法に基づく表示</v-btn
          ><br />
          <v-btn text class="login-footer" x-small href="https://mullion.jp/"
            >会社概要</v-btn
          >|<v-btn text class="login-footer" x-small @click="toSitePolicy"
            >利用規約</v-btn
          >
        </div>
      </div>
    </div>
    <div v-show="isInputPhoneNum && !smsSent">
      <v-row class="login-header" align="center" no-gutters>
        <v-col cols="1">
          <v-icon @click="backHome" dark>mdi-arrow-left</v-icon>
        </v-col>
        <v-col cols="10"> 電話番号を認証 </v-col>
        <v-col cols="1"> </v-col>
      </v-row>
      <v-row no-gutters justify="center" class="my-auto">
        <v-col cols="12">
          <div
            class="text-center text-p"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            電話番号を入力してください
          </div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="phoneNumber"
            outlined
            dense
            full-width
            class="px-5"
          />
        </v-col>
        <v-col cols="12">
          <div style="font-size: 8px" class="px-5 text-left mb-5">
            mullionは、携帯電話の認証のため、SMS(テキスト)が送信されます。これには、SMS料金及びデータ料金がかかる場合があります。
          </div>
        </v-col>
        <v-col cols="12">
          <v-btn id="cast-sign-in-button" @click="signIn" width="250px"
            >SMSを使用</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div v-show="isInputPhoneNum && smsSent">
      <v-row class="login-header" align="center" no-gutters>
        <v-col cols="1">
          <v-icon @click="backPhoneNum" dark>mdi-arrow-left</v-icon>
        </v-col>
        <v-col cols="10"> 電話番号を認証 </v-col>
        <v-col cols="1"> </v-col>
      </v-row>
      <v-row no-gutters justify="center" class="my-auto">
        <v-col cols="12">
          <div
            class="text-center text-p"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            コードを入力してください
          </div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="otpnum"
            maxlength="6"
            outlined
            dense
            full-width
            class="px-5"
          />
        </v-col>
        <v-col cols="12">
          <v-btn
            class="login-btn mb-4"
            color="#000"
            @click="sendCode"
            width="250px"
            >次へ</v-btn
          >
          <v-divider class="px-5" />
          <v-btn
            @click="resendCode"
            class="white--text mt-4"
            color="#000"
            width="200px"
            x-small
            >SMSが届かない場合はこちら</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="app_ver_txt">APP_VERSION:{{ app_ver }}</div>
  </div>
</template>
<script>
import Vue from "vue";
import { CommonApi } from "@/adapter/commonApi";
import { auth } from "@/plugins/firebase";
import { validateHalfNumbers } from "@/helper/utils/stringUtils";
import { SexTypes, UserTypes } from "@/types/abstract";
import {
  route_privacyPolicy,
  route_sitePolicy,
  route_terms,
  route_waiting,
  route_mypage,
} from "@/router";
import { signOut } from "firebase/auth";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { CastApi } from "@/adapter/castApi";
import { initCast } from "@/types/cast";
export default Vue.extend({
  data: () => ({
    app_ver: process.env.VUE_APP_VERSION,
    phoneNumber: "",
    otpnum: "",
    recaptchaVerifier: null,
    confirmResult: null,
    smsSent: false,
    isInputPhoneNum: false,
  }),
  mounted() {
    this.initRecaptcha();
  },
  methods: {
    toInputPhonenNum() {
      this.isInputPhoneNum = true;
    },
    backHome() {
      this.isInputPhoneNum = false;
    },
    backPhoneNum() {
      this.smsSent = false;
    },
    toPrivacyPolicy() {
      this.$router.push(route_privacyPolicy);
    },
    toTerms() {
      this.$router.push(route_terms);
    },
    toSitePolicy() {
      this.$router.push(route_sitePolicy);
    },
    initRecaptcha() {
      this.recaptchaVerifier = new RecaptchaVerifier(
        "cast-sign-in-button",
        {
          size: "invisible",
        },
        auth
      );
    },
    validateBeforeSentSms() {
      if (
        this.phoneNumber.length < 9 ||
        !validateHalfNumbers(this.phoneNumber)
      ) {
        alert("電話番号の形式が不正です。再度ご確認ください。");
        return false;
      }

      return true;
    },
    async signIn() {
      if (!this.validateBeforeSentSms()) {
        return;
      }
      this.$store.dispatch("startLoading");
      // 日本で固定
      const conutryNum = "+81";
      await signInWithPhoneNumber(
        auth,
        conutryNum + this.phoneNumber.substr(1),
        this.recaptchaVerifier
      )
        .then((confirmationResult) => {
          this.confirmResult = confirmationResult;

          this.smsSent = true;
          this._finishLoading();
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          // window.confirmationResult = confirmationResult;
        })
        .catch((error) => {
          this.smsSent = false;
          if (error.code == "auth/too-many-requests") {
            alert(
              "ログイン試行回数が上限に達したため一時的にアカウントをロックしています。お手数ですがお時間をおいて再度お試しください。"
            );
          } else {
            console.log(error);
            alert(
              "SMS送信処理に失敗しました。再度ご確認の上入力してください。"
            );
          }
          this._finishLoading();
          // Error; SMS not sent
          // ...
          // this.recaptchaVerifier.render().then(function (widgetId) {
          //   this.recaptchaVerifier.reset(widgetId);
          // });
          this.initRecaptcha();
        });
    },
    sendCode() {
      if (this.otpnum.length != 6 || !validateHalfNumbers(this.otpnum)) {
        alert("SMSコードが不正です。再度ご確認ください。");
        return;
      }
      this.$store.dispatch("startLoading");
      let code = this.otpnum;
      this.confirmResult
        .confirm(code)
        .then(async (result) => {
          // User signed in successfully.
          let user = result.user;
          if (!result.additionalUserInfo?.isNewUser) {
            // ユーザーの情報を取得
            const users = new CommonApi();
            const userInfo = await users.getUserInfo();
            if (!userInfo || !userInfo.data) {
              // 過去ログインはしているがまだユーザを作成されていない場合
              await this.initUser();
            } else {
              if (
                (userInfo.data.sex == SexTypes.Man) |
                (userInfo.data.userType == UserTypes.Guest)
              ) {
                // 性別が違うためキャストログインにリダイレクト
                await this.signOutAndAlert();
                return;
              }
              await this.$store.dispatch("userData/setUserData", userInfo.data);
            }
          }
          // ユーザ情報を設定
          user.sex = SexTypes.Woman;
          user.userType = UserTypes.Cast;

          await this.$store.dispatch("auth/registerUserInfo", user);

          if (result.additionalUserInfo?.isNewUser) {
            // 新規ユーザの場合
            await this.initUser();
            this.$store.dispatch("finishLoading");
            this.$router.push(route_waiting);
            return;
          }

          // 登録済みユーザーのログインの場合
          this.$store.dispatch("finishLoading");
          this.$router.push(route_mypage);
          return;
        })
        .catch(function(error) {
          alert(
            "smsコード認証に失敗しました。再度ご確認の上入力してください。"
          );
          // User couldn't sign in (bad verification code?)
          console.log(error);
        });
      this.$store.dispatch("finishLoading");
    },
    async initUser() {
      // キャストユーザーを作成
      const casts = new CastApi();
      await casts.setCastData({
        sex: SexTypes.Woman,
        userType: UserTypes.Cast,
      });
      await this.$store.dispatch("userData/setUserData", initCast);
    },
    async signOutAndAlert() {
      await signOut(auth).then(() => {
        alert(
          "この番号はゲストとして登録済みです。心当たりがない場合はお問い合わせください。"
        );
      });
    },
    async resendCode() {
      await this.signIn();
      alert("SMSを再送しました。ご確認ください。");
    },
    async _finishLoading() {
      await this.$store.dispatch("finishLoading");
    },
  },
});
</script>

<style lang="scss" scoped>
.login-header {
  font-size: 14px !important;
  color: white;
  background-color: #000;
  height: 40px;
}
.login-btn {
  background-color: #000;
  color: white;
}
.login-footer {
  font-size: 8px !important;
  color: #6e5c26;
}
.gold-color {
  color: #6e5c26;
}
#cast-sign-in-button {
  background-color: #000;
  color: white;
}
.app_ver_txt {
  font-size: 8px;
  position: absolute;
  right: 4px;
  bottom: 4px;
}
</style>
